import React, { useEffect, useState } from "react";
import AddIcon from "@mui/icons-material/Add";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import KeyboardArrowLeftIcon from "@mui/icons-material/KeyboardArrowLeft";
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";
import FirstPageIcon from "@mui/icons-material/FirstPage";
import LastPageIcon from "@mui/icons-material/LastPage";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import IconButton from "@mui/material/IconButton";
import { AddButton, DeleteButton } from "../../../../utils/Custom/Button";
import { useLocation, useNavigate } from "react-router-dom";
import { submitSiteDelete } from "../../../../utils/commonComponent/delete";
import { fetchQuery } from "../../../../utils/commonComponent/fetched";
import ListSearchSection from "../../../../utils/Custom/ListSearchSection";
import axiosWithToken from "../../../../utils/commonComponent/axiosTokenConfig";
import { BASE_URL } from "../../../../global";
import moment from "moment";
import { getPermissions } from "../../rbac/hasAccess";
import { paginationrowsPerPageOptions } from "../../../../utils/commonComponent/commonConstant";
import { textTruncate } from "../../../../utils/commonComponent/truncate";

const headers = [
  "id",
  // "Client",
  "Manufacturer_Supplier",
  "Contractor_Client",
  "reportNo",
  // "address",
  // "poNumber",
  // "jobNumber",
  // "inspectionNumber",
  // "Items",
  // "InspectedBy",
];

const fields = [
  { value: "Client", label: "Client" },
  { value: "reportNo", label: "Report No" },
  { value: "supplier", label: "Manufacturer Supplier" },
  // { value: "inspectionNumber", label: "Inspection No" },
  // { value: "poNumber", label: "Po No" },
];

const CreateCoverLetterList = (props) => {
  const navigate = useNavigate();
  const location = useLocation();
  const permissions = getPermissions(props.moduleId);
  const handleEdit = (row) => navigate(`/createReport/${row.id}`);
  const handleDelete = (row) => submitSiteDelete("IR_coverLetter", row.id, 2);

  const [coveerLetterList, setCoverLetterList] = useState([]);
  const [totalRows, setTotalRows] = useState(0);
  const [searchBy, setSearchBy] = React.useState(sessionStorage.getItem("searchBy") || "Client");
  const [searchKey, setSearchKey] = React.useState(sessionStorage.getItem("searchKey") || "");
  const [searched, setSearched] = React.useState(sessionStorage.getItem("searched") === "true" || false);
  // Pagination
  const [currentPage, setCurrentPage] = useState(() => Number(sessionStorage.getItem("ListPageCount") || 0));
  const [rowsPerPage, setRowsPerPage] = useState(() => Number(sessionStorage.getItem("ListRowsPerPage") || 30));

  const [selectedIds, setSelectedIds] = useState([]);
  const [inpectorList, setinpectorList] = useState([]);

  // Menu states
  const [menuAnchorEl, setMenuAnchorEl] = useState(null);
  const [menuRow, setMenuRow] = useState(null);

  const userType = localStorage.getItem("type") || "";
  const inspectorId = localStorage.getItem("inspectorId") || "";

  const handlePaginationChange = (page, rows) => {
    setCurrentPage(page);
    setRowsPerPage(rows);
    // fetch new data from backend here
    sessionStorage.setItem("ListPageCount", page);
    sessionStorage.setItem("ListRowsPerPage", rows);
  };

  const handleMenuOpen = (event, row) => {
    setMenuAnchorEl(event.currentTarget);
    setMenuRow(row);
  };

  const handleMenuClose = () => {
    setMenuAnchorEl(null);
    setMenuRow(null);
  };

  const handleSelectRow = (id) => {
    const updated = selectedIds.includes(id)
      ? selectedIds.filter((item) => item !== id)
      : [...selectedIds, id];
    setSelectedIds(updated);
  };

  const handleSelectAll = () => {
    if (selectedIds.length === coveerLetterList.length) {
      setSelectedIds([]);
    } else {
      const allIds = coveerLetterList.map((row) => row.id);
      setSelectedIds(allIds);
    }
  };

  const isAllSelected = selectedIds.length === coveerLetterList.length && coveerLetterList.length > 0;

  const handleMultipleDelete = () => {
    submitSiteDelete("IR_coverLetter", selectedIds, 2);
  };

  const getWhereClause = () => {
    let whereConditions = "";
    const colMap = {
      Client: "contractorClient",
      reportNo: "reportNo",
      supplier: "supplierName",
      // inspectionNumber: "jri.inspectionNumber",
      // poNumber: "jr.poNumber",
    };
    const colName = colMap[searchBy];
    if (colName && searchKey.trim()) {
      whereConditions += `WHERE LOWER(${colName}) LIKE LOWER('%${searchKey.trim()}%')`;
    }
    // if (userType == 2) {
    //   whereConditions += whereConditions
    //     ? ` AND jri.inspectorId = ${inspectorId}`
    //     : `WHERE jri.inspectorId = ${inspectorId}`;
    // }

    // Always include ir.mode = 1
    whereConditions += whereConditions ? ` AND mode = 1` : `WHERE mode = 1`;

    return whereConditions;
  };

  const getDataQuery = () => {
    const whereClause = getWhereClause();
    let paginationSettings = "";
    if (rowsPerPage !== -1) {
      paginationSettings = `LIMIT ${rowsPerPage} OFFSET ${rowsPerPage * Number(currentPage)}`;
    }
    return `SELECT id, clientId as Client, reportNo, supplierName as Manufacturer_Supplier, contractorClient as Contractor_Client from IR_coverLetter ${whereClause} ORDER BY id DESC ${paginationSettings};`;
  };

  const getCountQuery = () => {
    const whereClause = getWhereClause();
    return `SELECT COUNT(*) AS totalRows FROM IR_coverLetter ${whereClause};`;
  };

  const fetchData = async () => {
    try {
      const [inspectionData, countResult] = await Promise.all([
        fetchQuery(getDataQuery()),
        fetchQuery(getCountQuery()),
      ]);
      let modifiedData = inspectionData?.map((item) => {
        const inspectorType = inpectorList.find((el) => el.id == item.inspectorId);
        return {
          ...item,
          Items: item.subcategory || "",
          "InspectedBy": inspectorType ? inspectorType.name : null,
        };
      });
      setCoverLetterList(modifiedData);
      setTotalRows(countResult?.[0]?.totalRows || 0);
    } catch (error) {
      console.error("Error fetching user data:", error);
    }
  };

  const handleSearch = () => {
    if (!searchBy || !searchKey.trim()) {
      alert("Please select a search field and enter a search value.");
      return;
    }
    fetchData();
    setSearched(true);
    // Save search state to sessionStorage
    sessionStorage.setItem("searchBy", searchBy);
    sessionStorage.setItem("searchKey", searchKey);
    sessionStorage.setItem("searched", "true");
    sessionStorage.setItem("currentPath", location.pathname);
    sessionStorage.setItem("ListPageCount", 0);
    setCurrentPage(0);
  };

  const handleCopy = async (row) => {
    const numberOfCopies = parseInt(window.prompt("Enter the number of copies you want to create for the selected letter:", "1"), 10);
    if (isNaN(numberOfCopies) || numberOfCopies <= 0) {
      return;
    }
    try {
      const query = `select * from IR_coverLetter where id = ${row.id}`;
      const [currentCoverIDData] = await fetchQuery(query);
      const { id, ...payload } = currentCoverIDData;

      // Get headers and body data for the original cover letter
      const [headers, bodyData] = await Promise.all([
        fetchQuery(
          `SELECT * FROM dynamicTableHeader WHERE type = 2 AND jobInspectionId = ${id}`
        ),
        fetchQuery(
          `SELECT * FROM dynamicTableBody WHERE type = 2 AND jobInspectionId = ${id}`
        ),
      ]);

      for (let i = 0; i < numberOfCopies; i++) {
        // 1. Create new cover letter
        const newCoverLetterResponse = await axiosWithToken.post(`${BASE_URL}IR_coverLetter`, payload);
        // Get the new cover letter ID (adjust based on your API response structure)
        let newCoverLetterId;
        if (newCoverLetterResponse.data && newCoverLetterResponse.data.id) {
          newCoverLetterId = newCoverLetterResponse.data.id;
        } else {
          // If API doesn't return ID, fetch the latest one
          const [latestCoverLetter] = await fetchQuery(
            `SELECT id FROM IR_coverLetter ORDER BY id DESC LIMIT 1`
          );
          newCoverLetterId = latestCoverLetter.id;
        }

        // 2. Copy headers if they exist
        if (headers && headers.length > 0) {
          const headerPromises = headers.map(header => {
            // Remove id and update jobInspectionId
            const { id, jobInspectionId, ...headerPayload } = header;
            return axiosWithToken.post(`${BASE_URL}dynamicTableHeader`, {
              ...headerPayload,
              jobInspectionId: newCoverLetterId
            });
          });
          await Promise.all(headerPromises);
        }
        // 3. Copy body data if it exists
        if (bodyData && bodyData.length > 0) {
          const bodyPromises = bodyData.map(body => {
            // Remove id and update jobInspectionId
            const { id, jobInspectionId, ...bodyPayload } = body;
            return axiosWithToken.post(`${BASE_URL}dynamicTableBody`, {
              ...bodyPayload,
              jobInspectionId: newCoverLetterId
            });
          });
          await Promise.all(bodyPromises);
        }
      }
      setTimeout(() => window.location.reload(), 500);
    } catch (error) {
      console.error('Error copying cover letter:', error);
    }
  };

  const clearSearch = () => {
    setSearched(false);
    setSearchBy("Client");
    setSearchKey("");
    // Clear all employee list session storage
    sessionStorage.removeItem("ListPageCount");
    sessionStorage.removeItem("ListRowsPerPage");
    sessionStorage.removeItem("searchBy");
    sessionStorage.removeItem("searchKey");
    sessionStorage.removeItem("searched");
    setCurrentPage(0);
  };

  const fetchinpectorsList = async () => {
   const query = `SELECT user.*, emp.name, emp.location FROM users user LEFT JOIN employees emp ON user.employeeId = emp.id WHERE user.type = 2 AND user.status = 1`;
    const res = await fetchQuery(query);
    setinpectorList(res);
  };

  useEffect(() => {
    fetchData();
  }, [inpectorList, currentPage, rowsPerPage]);

  useEffect(() => {
    fetchinpectorsList();
  }, []);

  useEffect(() => {
    if (searched == false) {
      fetchData();
    }
  }, [searched]);

  return (
    <>
      {(permissions.create || permissions.allAccess) && (
        <AddButton
          id="btn-add-outline"
          to="/createReport/0"
          label="Add Office Cover Letter"
          icon={<AddIcon fontSize="small" />}
        />
      )}

      <ListSearchSection
        title="Search Cover Letter"
        fields={fields}
        onSearch={handleSearch}
        searchKey={searchKey}
        setSearchKey={setSearchKey}
        searchBy={searchBy}
        setSearchBy={setSearchBy}
        clearSearch={clearSearch}
        searched={searched}
        setSearched={setSearched}
      />

      {selectedIds.length > 0 && (
        <div className="shadow-sm p-2 pt-1 mb-2 bg-white">
          <DeleteButton
            id="btn-multi-delete"
            label="Multiple Delete"
            onClick={handleMultipleDelete}
          />
        </div>
      )}

      <div className="w-full border rounded-md shadow">
        {/* Table Container with Fixed Height */}
        <div className="overflow-y-auto h-auto max-h-[450px]">
          <table className="min-w-full text-sm text-left text-gray-700">
            <thead className="sticky top-0 bg-blue-50 text-xs  font-medium text-gray-600 z-10">
              <tr>
                <th className="px-2 py-3 text-center">
                  <input
                    type="checkbox"
                    checked={isAllSelected}
                    onChange={handleSelectAll}
                  />
                </th>
                <th className="px-4 py-3 whitespace-nowrap">Sr. No.</th>
                <th className="px-4 py-3 whitespace-nowrap">Manufacturer Supplier</th>
                <th className="px-4 py-3 whitespace-nowrap">Contractor Client</th>
                <th className="px-4 py-3 whitespace-nowrap">Report No</th>
                {(permissions.edit || permissions.delete || permissions.pdfDownload || permissions.allAccess) && (
                  <th className="px-4 py-3 whitespace-nowrap text-center capitalize">ACTIONS</th>
                )}
              </tr>
            </thead>
            <tbody className="divide-y divide-gray-200">
              {coveerLetterList.map((row, rowIndex) => (
                <tr key={rowIndex}>
                  <td className="px-2 py-2 text-center">
                    <input
                      type="checkbox"
                      checked={selectedIds.includes(row.id)}
                      onChange={() => handleSelectRow(row.id)}
                    />
                  </td>
                  <td className="px-4 py-3">{currentPage * rowsPerPage + rowIndex + 1}
                  </td>
                  <td className="px-4 py-3">{textTruncate(row.Manufacturer_Supplier) ?? "-"}
                  </td>
                  <td onClick={() => handleEdit(row)} className="cursor-pointer hover:text-blue-600 px-4 py-3">{textTruncate(row.Contractor_Client) ?? "-"}
                  </td>
                  <td onClick={() => handleEdit(row)} className="cursor-pointer hover:text-blue-600 px-4 py-3 whitespace-nowrap">{row.reportNo ?? "-"}
                  </td>
                  {(permissions.edit || permissions.delete || permissions.pdfDownload || permissions.copy || permissions.allAccess) && (
                    <td className="px-4 py-2 text-center whitespace-nowrap">
                      <div className="flex items-center justify-center gap-2">
                        {(permissions.edit || permissions.allAccess) && (
                          <button
                            onClick={() => handleEdit(row)}
                            className="text-blue-600"
                          >
                            <EditIcon fontSize="small" />
                          </button>
                        )}
                        {(permissions.delete || permissions.allAccess) && (
                          <button
                            onClick={() => handleDelete(row)}
                            className="text-blue-600"
                          >
                            <DeleteIcon fontSize="small" />
                          </button>
                        )}
                        {(permissions.pdfDownload || permissions.copy || permissions.allAccess) && (
                          <IconButton
                            size="small"
                            onClick={(e) => handleMenuOpen(e, row)}
                            className="text-blue-600"
                          >
                            <MoreVertIcon fontSize="small" />
                          </IconButton>
                        )}
                        <Menu
                          anchorEl={menuAnchorEl}
                          open={Boolean(menuAnchorEl && menuRow === row)}
                          onClose={handleMenuClose}
                        >
                          {(permissions.pdfDownload || permissions.allAccess) && (
                            <MenuItem
                              onClick={() => {
                                handleMenuClose();
                                navigate(`/createReport/print/${menuRow.id}`);
                              }}
                            >
                              <PictureAsPdfIcon
                                fontSize="small"
                                className="text-blue-600 mr-2"
                              />
                              Pdf
                            </MenuItem>
                          )}
                          {(permissions.copy || permissions.allAccess) && (
                            <MenuItem
                              onClick={() => {
                                handleMenuClose();
                                handleCopy(menuRow);
                              }}
                            >
                              <ContentCopyIcon
                                fontSize="small"
                                className="text-blue-600 mr-2"
                              />
                              Copy
                            </MenuItem>
                          )}
                        </Menu>
                      </div>
                    </td>
                  )}
                </tr>
              ))}
              {coveerLetterList.length === 0 && (
                <tr>
                  <td
                    colSpan={headers.length + 2}
                    className="text-center py-4 text-gray-500"
                  >
                    No data available.
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>

        {/* Pagination Footer */}
        <div className="flex items-center justify-between px-4 py-2 bg-blue-50 text-sm border-t">
          <div className="flex items-center gap-2">
            <span>Rows per page:</span>
            <select
              value={rowsPerPage}
              onChange={(e) => handlePaginationChange(0, Number(e.target.value))}
              className="border rounded px-2 py-1 text-sm"
            >
              {paginationrowsPerPageOptions.map((option) => (
                <option key={option} value={option}>
                  {option}
                </option>
              ))}
            </select>
          </div>

          <div className="flex items-center gap-2">
            <span className="text-gray-600">
              {totalRows === 0
                ? "0–0 of 0"
                : `${currentPage * rowsPerPage + 1}–${Math.min(
                  (currentPage + 1) * rowsPerPage,
                  totalRows
                )} of ${totalRows}`}
            </span>
            <button
              onClick={() => handlePaginationChange(0, rowsPerPage)}
              disabled={currentPage === 0}
              className="p-1 disabled:opacity-50"
            >
              <FirstPageIcon fontSize="small" />
            </button>
            <button
              onClick={() => handlePaginationChange(currentPage - 1, rowsPerPage)}
              disabled={currentPage === 0}
              className="p-1 disabled:opacity-50"
            >
              <KeyboardArrowLeftIcon fontSize="small" />
            </button>
            <button
              onClick={() => handlePaginationChange(currentPage + 1, rowsPerPage)}
              disabled={currentPage >= Math.ceil(totalRows / rowsPerPage) - 1}
              className="p-1 disabled:opacity-50"
            >
              <KeyboardArrowRightIcon fontSize="small" />
            </button>
            <button
              onClick={() => handlePaginationChange(Math.ceil(totalRows / rowsPerPage) - 1, rowsPerPage)}
              disabled={currentPage >= Math.ceil(totalRows / rowsPerPage) - 1}
              className="p-1 disabled:opacity-50"
            >
              <LastPageIcon fontSize="small" />
            </button>
          </div>
        </div>
      </div>
    </>
  );
};

export default CreateCoverLetterList;
